import { empresaRepository, EmpresaRepository } from './EmpresaRepository'
import type { EmpresaSettings } from './types'

export class EmpresaService {
  private readonly repository: EmpresaRepository

  constructor(repository: EmpresaRepository = empresaRepository) {
    this.repository = repository
  }

  get(): EmpresaSettings {
    return this.repository.get()
  }

  update(patch: Partial<EmpresaSettings>): EmpresaSettings {
    const current = this.repository.get()
    const next: EmpresaSettings = {
      ...current,
      ...patch,
      endereco: {
        ...current.endereco,
        ...(patch.endereco ?? {}),
      },
    }
    this.repository.save(next)
    return next
  }

  reset(): EmpresaSettings {
    return this.repository.reset()
  }
}

export const empresaService = new EmpresaService()
